const FormularioList = (props) => {
  const temErro = Boolean(props.error);

  return (
    <div className={`form-group ${props.size} ${temErro ? "has-error" : ""}`}>
      <label htmlFor={props.id}>
        {props.title}{" "}
        <span className={props.required}>
          {props.required === "required" ? "*" : ""}
        </span>
      </label>

      <select
        id={props.id}
        name={props.id}
        required={props.required === "required"}
        value={props.valor}
        onChange={(evento) => props.aoAlterado(evento.target.value)}
        className={temErro ? "input-error" : ""}
      >
        <option value="">Selecione</option>
        {props.itens.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>

      {temErro ? (
        <div className="error-text">{props.error}</div>
      ) : (
        <div className="helper">{props.helper}</div>
      )}
    </div>
  );
};

export default FormularioList;
